import { h, Host, } from '@stencil/core';
import { send, paginationClickEvent, isAnalyticsEnabled, DEBOUNCED_HANDLER_DELAY } from '@pes-ui/utils';
import debounce from 'lodash/debounce';
import { scrollToTop } from '../../../globals/utils/helpers';
import { isMobile } from '../../../globals/utils';
export class ProductsPagination {
  constructor() {
    this.resizeWindow = () => {
      if (isMobile())
        this.updateLoadedRecNum();
    };
    this.debouncedHandleResize = debounce(this.resizeWindow, DEBOUNCED_HANDLER_DELAY);
    this.updateLoadedRecNum = () => {
      if (this.firstLoadedRecNumSaved > this.firstLoadedRecNum) {
        this.firstLoadedRecNumSaved = this.firstLoadedRecNum;
      }
      if (this.lastLoadedRecNumSaved < this.lastLoadedRecNum) {
        this.lastLoadedRecNumSaved = this.lastLoadedRecNum;
      }
    };
    this.loadPrevious = () => {
      const previousPageNumber = Math.floor(this.firstLoadedRecNum / this.productsPerPage);
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, { articleTitle: previousPageNumber });
      }
      this.pageSelected.emit(previousPageNumber);
      this.scrollToProduct.emit(this.productsPerPage);
    };
    this.loadMore = () => {
      const nextPageNumber = Math.floor(this.lastLoadedRecNum / this.productsPerPage) + 1;
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, { articleTitle: nextPageNumber });
      }
      this.pageSelected.emit(nextPageNumber);
      this.scrollToProduct.emit(this.lastLoadedRecNum - this.firstLoadedRecNum + 1);
    };
    this.onPaginationChange = (event) => {
      const { value: pageNumber, perPage: pageNoParam } = event.detail;
      if (isAnalyticsEnabled()) {
        send(paginationClickEvent, {
          articleTitle: pageNumber,
          pageNoParam: pageNumber * pageNoParam - pageNoParam,
        });
      }
      this.pageSelected.emit(pageNumber);
      scrollToTop(this.el);
    };
    this.loadMoreLabel = undefined;
    this.loadPreviousLabel = undefined;
    this.previousLabel = undefined;
    this.nextLabel = undefined;
    this.labelValue = undefined;
    this.firstLoadedRecNum = undefined;
    this.lastLoadedRecNum = undefined;
    this.showMobilePagination = undefined;
    this.showDesktopPagination = undefined;
    this.totalNumRecs = undefined;
    this.productsPerPage = undefined;
    this.selectedPage = undefined;
    this.productsCountLabel = undefined;
    this.firstLoadedRecNumSaved = 9999;
    this.lastLoadedRecNumSaved = 0;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillRender() {
    if (isMobile())
      this.updateLoadedRecNum();
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  getTotalPages() {
    return Math.ceil(this.totalNumRecs / this.productsPerPage);
  }
  render() {
    return (h(Host, null, this.showMobilePagination && this.productsCountLabel && (h("div", { class: "products-pagination__total-count" }, this.productsCountLabel, ": ", this.totalNumRecs)), this.showMobilePagination
      && !!this.totalNumRecs
      && this.firstLoadedRecNumSaved > 1
      && this.lastLoadedRecNumSaved < this.totalNumRecs && (h("qds-button", { class: "products-pagination__load-prev-btn", size: "large", importance: "standard", onClick: this.loadPrevious, text: this.loadPreviousLabel })), h("slot", null), this.showDesktopPagination && this.totalNumRecs > this.productsPerPage && (h("se-pagination", { class: "products-pagination__desktop", hideEdge: true, perPage: this.productsPerPage, total: this.getTotalPages(), value: this.selectedPage, labelValue: this.labelValue, labelPrev: this.previousLabel, labelNext: this.nextLabel, onDidChange: this.onPaginationChange })), this.showMobilePagination && this.lastLoadedRecNum < this.totalNumRecs && (h("qds-button", { class: "products-pagination__load-more-btn", size: "large", importance: "standard", text: this.loadMoreLabel, onClick: this.loadMore }))));
  }
  static get is() { return "pes-products-pagination"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["products-pagination.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["products-pagination.css"]
    };
  }
  static get properties() {
    return {
      "loadMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-more-label",
        "reflect": false
      },
      "loadPreviousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "load-previous-label",
        "reflect": false
      },
      "previousLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-label",
        "reflect": false
      },
      "nextLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "next-label",
        "reflect": false
      },
      "labelValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label-value",
        "reflect": false
      },
      "firstLoadedRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "first-loaded-rec-num",
        "reflect": false
      },
      "lastLoadedRecNum": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "last-loaded-rec-num",
        "reflect": false
      },
      "showMobilePagination": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-mobile-pagination",
        "reflect": false
      },
      "showDesktopPagination": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-desktop-pagination",
        "reflect": false
      },
      "totalNumRecs": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total-num-recs",
        "reflect": false
      },
      "productsPerPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-per-page",
        "reflect": false
      },
      "selectedPage": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-page",
        "reflect": false
      },
      "productsCountLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-count-label",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "firstLoadedRecNumSaved": {},
      "lastLoadedRecNumSaved": {}
    };
  }
  static get events() {
    return [{
        "method": "scrollToProduct",
        "name": "scrollToProduct",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event emitted the index of the product that should be scrolled into the view after loading another chunk of products\n(for mobile pagination)."
        },
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        }
      }, {
        "method": "pageSelected",
        "name": "pageSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event emitted on page select, contains number of the selected page."
        },
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
}
